import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const ProfessionalCredentialsSection = ({
  user,
  onEditDesignations,
  onEditLicenses
}) => {
  const intl = useIntl();

  const renderList = (items, emptyText) => {
    if (!items || items.length === 0) {
      return <p className="text-succession-text-muted italic">{emptyText}</p>;
    }
    return (
      <div className="flex flex-wrap gap-2">
        {items.map((item, index) => (
          <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-succession-bg-primary border border-succession-border text-succession-text-primary">
            {item}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="bg-succession-bg-secondary rounded-lg border border-succession-border p-6">
      <h3 className="text-xl font-semibold text-succession-text-primary mb-6">{intl.formatMessage({ id: 'succession.profile_edit.sections.professional_credentials.title' })}</h3>

      <div className="space-y-6">
        {/* Designations */}
        <div>
          <div className="flex items-center justify-between mb-3">
            <h4 className="text-sm font-medium text-succession-text-secondary">{intl.formatMessage({ id: 'succession.profile_edit.sections.professional_credentials.designations' })}</h4>
            <button
              onClick={onEditDesignations}
              className="inline-flex items-center px-3 py-1.5 border border-succession-border rounded-lg text-sm text-succession-text-primary hover:bg-succession-bg-primary transition-colors"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              {intl.formatMessage({ id: 'succession.profile_edit.common.edit' })}
            </button>
          </div>
          {renderList(user.designations, intl.formatMessage({ id: 'succession.profile_edit.sections.professional_credentials.no_designations' }))}
        </div>

        {/* Advisor Licenses */}
        <div>
          <div className="flex items-center justify-between mb-3">
            <h4 className="text-sm font-medium text-succession-text-secondary">{intl.formatMessage({ id: 'succession.profile_edit.sections.professional_credentials.advisor_licenses' })}</h4>
            <button
              onClick={onEditLicenses}
              className="inline-flex items-center px-3 py-1.5 border border-succession-border rounded-lg text-sm text-succession-text-primary hover:bg-succession-bg-primary transition-colors"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              {intl.formatMessage({ id: 'succession.profile_edit.common.edit' })}
            </button>
          </div>
          {renderList(user.advisor_licenses, intl.formatMessage({ id: 'succession.profile_edit.sections.professional_credentials.no_licenses' }))}
        </div>
      </div>
    </div>
  );
};

ProfessionalCredentialsSection.propTypes = {
  user: PropTypes.object.isRequired,
  onEditDesignations: PropTypes.func.isRequired,
  onEditLicenses: PropTypes.func.isRequired,
};

export default ProfessionalCredentialsSection;
